// LoadingSpinner.jsx
import styles from "./LoadingSpinner.module.css";

const Loader = ({ 
  message = "Laddar...", 
  submessage = "Vänta tills sidan har laddat klart",
  showSubmessage = true
}) => {
  return (
    <div className={styles.loader_container}>
      <div className={styles.loader_inner}>
        <div className={styles.loader} />
        <p className="body1 text-center">{message}</p>
        {showSubmessage && <p className="light text-center">{submessage}</p>}
      </div>
    </div>
  );
};

export const ScreenLoader = () => <Loader />;
export const DataLoader = () => <Loader message="Läser in data..." showSubmessage={false} />;
export const SignInLoader = () => <Loader message="Loggar in..." showSubmessage={false} />;
export const SignOutLoader = () => <Loader message="Loggar ut..." showSubmessage={false} />;

export default Loader;